import GlobalVars from 'Utils/global-vars';
import sitemapClient from './client';

const sitemap = GlobalVars.isServer()
  ? eval(`require('./server')`).default // hide from webpack so not bundled
  : sitemapClient;
export default sitemap;
